import styled from 'styled-components';

export const LazyLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
`;
